module.exports = {
	"classes": [
		"new-homepage-page",
		"header-dark"
	],
	"title": "Single Sign On & Token Based Authentication",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/homepage/data/metadata.json
// module id = 1395
// module chunks = 0